import { render, staticRenderFns } from "./payoutsPage.vue?vue&type=template&id=019e242c&scoped=true&"
import script from "./payoutsPage.vue?vue&type=script&lang=js&"
export * from "./payoutsPage.vue?vue&type=script&lang=js&"
import style0 from "./payoutsPage.vue?vue&type=style&index=0&id=019e242c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e242c",
  null
  
)

export default component.exports